/* eslint-disable @typescript-eslint/no-unsafe-call */
import React from "react";
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/system";
import { IconButton, Typography, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { OrderDetailsTextArea } from "./orderDetailsTextArea";

interface ISidebarOrderDetailsProps {
    value: string;
    driverComments: string;
    onClose: () => void;
    onSaveSuccess: (val: string) => void;
    autoFocus: boolean;
}

export const SidebarOrderDetails = ({
    value,
    driverComments,
    onClose,
    onSaveSuccess,
    autoFocus,
}: ISidebarOrderDetailsProps) => {
    const { t } = useTranslation();

    return (
        <Stack spacing={2} sx={{ width: "100%" }} fontSize="small">
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
            >
                <Typography variant="h4">{t("common.additionalDetails")}</Typography>
                <Box>
                    <IconButton className="close-panel-button" size="small" onClick={onClose}>
                        <CloseIcon color="primary" />
                    </IconButton>
                </Box>
            </Stack>
            <OrderDetailsTextArea
                autoFocus={autoFocus}
                disabled={false}
                value={value ?? ""}
                maxLength={1000}
                onBlur={(transportDetails: string) => void onSaveSuccess(transportDetails)}
                driverComments={driverComments}
            />
        </Stack>
    );
};
